var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "h-full" }, [
    _c(
      "div",
      { staticClass: "h-full flex flex-col", staticStyle: { width: "100%" } },
      [
        _c("div", { staticClass: "flex-1 flex overflow-hidden" }, [
          _c("div", { staticClass: "flex-1 flex overflow-hidden" }, [
            _c("div", { staticClass: "flex-1 flex overflow-hidden" }, [
              _vm.hasLoaded
                ? _c(
                    "main",
                    { staticClass: "flex-1 flex bg-gray-200" },
                    [_c("InboxSidebar"), _c("router-view")],
                    1
                  )
                : _c("span", [_vm._v(" Loading team inbox.... ")])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }